// extracted by mini-css-extract-plugin
export default {"container":"Application_container__k4khE","h1":"Application_h1__Wgp-M","perm_add":"Application_perm_add__WmPvy","submit":"Application_submit__oxsxc"};